import React from "react";
import ReactDOM from "react-dom";
import "./i18n";
import "./index.css";
import "./lib/article-editor/article-editor-layout.css";
import EmployeeUIApp from "./EmployeeUIApp";

ReactDOM.render(<EmployeeUIApp />, document.getElementById("root"));
